<template>
  <div ref="toast" :class="$style.toast" v-show="use" :style="{top:top,left:left}">
     <div v-if="type.default">{{this.info}}</div>
     <div v-else-if="type.success"><p><img src="../../assets/img/common/success.svg"/></p>{{this.info}}</div>
     <div v-else-if="type.error"><p><img src="../../assets/img/common/error.svg"/></p>{{this.info}}</div>
  </div>
</template>

<script>
  import bus from '../../assets/js/common/bus.js'
  import { setTimeout } from 'timers';

  export default {
    name: 'toast',
    props:[],
    data () {
      return {
          use:false,
          type:{
              default:false,
              success:false,
              error:false,
          },
          info:'',
          left:0,
          top:0,
      }
    },
    mounted () {
        bus.$on('toast', (info ,timer = 2000, params) => {
          this.toastShow('default',info,timer, params)
        })

        bus.$on('success', (info ,timer = 2000) => {
          this.toastShow('success',info,timer)
        })

        bus.$on('error', (info ,timer = 2000) => {
          this.toastShow('error',info,timer)
        })
    },
    watch: {

    },
    methods: {
        toastShow: function(type,info,timer, params){
            if(!info || info === 'null') return;
            this.info = info;
            this.use = true;
            this.type[type] = true;
            this.$nextTick(() => {
                const divWidth = this.$refs.toast.offsetWidth
                const divHeight = this.$refs.toast.offsetHeight
                const viewWidth = document.documentElement.clientWidth || document.body.clientWidth
                const viewHeight = document.documentElement.clientHeight || document.body.clientHeight
                const left = (viewWidth - divWidth) / 2
                const top = (viewHeight - divHeight) / 2
                this.left = `${left}px`
                this.top = `${top}px`
                if(params && params.left) {
                  this.left = `${params.left}px`
                }
                setTimeout(() => {
                    this.use = false;
                    this.type[type] = false;
                    this.info = '';
                },timer)
            })
        }
    }
  }
</script>

<style lang="postcss" module>
    .toast{
        position:fixed;
        top:50%;
        left:50%;
        padding:20px;
        background-color: rgba(0,0,0,0.4);
        color:#f3f4f5;
        border-radius: 4px;
        border: none;
        font-size:14px;
        font-weight:400;
        z-index:999;
        text-align:center;
    }
    .toast p{
        margin-bottom:10px;
    }
    .toast img{
        widows: 32px;
        height: 32px;
    }
</style>



// WEBPACK FOOTER //
// toast.vue?b63e5186